import single from '../images/shapes/single.png';
import double from '../images/shapes/double.png';
import triple from '../images/shapes/triple.png';
import quad from '../images/shapes/quad.png';
import doubleScaffolded from '../images/shapes/double-scaffolded.png';
import tripleScaffolded from '../images/shapes/triple-scaffolded.png';
import quadScaffolded from '../images/shapes/quad-scaffolded.png';
import spacer from '../images/shapes/spacer.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import {faRectangle} from '@fortawesome/sharp-solid-svg-icons';
import ReactDOMServer from 'react-dom/server';

const circle = ReactDOMServer.renderToString(<FontAwesomeIcon icon={faCircle} />);
const rectangle = ReactDOMServer.renderToString(<FontAwesomeIcon icon={faRectangle} />);

const shapes = {
  'singleBox': {
    id: 'singleBox',
    title: '1-Letter',
    subtitle: 'Box, Plain',
    type: 'BOX',
    maxItems: 1,
    isScaffolded: false,
    imageSrc: single,
    thumbImageSrc: single,
  },
  'doubleBox': {
    id: 'doubleBox',
    title: '2-Letter',
    subtitle: 'Box, Plain',
    type: 'BOX',
    maxItems: 2,
    isScaffolded: false,
    imageSrc: double,
    thumbImageSrc: double,
  },
  'tripleBox': {
    id: 'tripleBox',
    title: '3-Letter',
    subtitle: 'Box, Plain',
    type: 'BOX',
    maxItems: 3,
    isScaffolded: false,
    imageSrc: triple,
    thumbImageSrc: triple,
  },
  'quadBox': {
    id: 'quadBox',
    title: '4-Letter',
    subtitle: 'Box, Plain',
    type: 'BOX',
    maxItems: 4,
    isScaffolded: false,
    imageSrc: quad,
    thumbImageSrc: quad,
  },
  'doubleBoxScaffolded': {
    id: 'doubleBoxScaffolded',
    title: '2-Letter',
    subtitle: 'Box, Scaffolded',
    type: 'BOX',
    maxItems: 2,
    isScaffolded: true,
    imageSrc: doubleScaffolded,
    thumbImageSrc: doubleScaffolded,
  },
  'tripleBoxScaffolded': {
    id: 'tripleBoxScaffolded',
    title: '3-Letter',
    subtitle: 'Box, Scaffolded',
    type: 'BOX',
    maxItems: 3,
    isScaffolded: true,
    imageSrc: tripleScaffolded,
    thumbImageSrc: tripleScaffolded,
  },
  'quadBoxScaffolded': {
    id: 'quadBoxScaffolded',
    title: '4-Letter',
    subtitle: 'Box, Scaffolded',
    type: 'BOX',
    maxItems: 4,
    isScaffolded: true,
    imageSrc: quadScaffolded,
    thumbImageSrc: quadScaffolded,
  },
  'cardBlack': {
    id: 'cardBlack',
    component: rectangle,
    title: 'Card',
    subtitle: 'Black',
    type: 'CARD',
    colorHex: '#000',
    dropShadow: false,
    widthScale: .73,
  },
  'cardGray': {
    id: 'cardGray',
    component: rectangle,
    title: 'Card',
    subtitle: 'Gray',
    type: 'CARD',
    colorHex: '#8e97a0',
    dropShadow: false,
    widthScale: .73,
  },
  'cardBlue': {
    id: 'cardBlue',
    component: rectangle,
    title: 'Card',
    subtitle: 'Blue',
    type: 'CARD',
    colorHex: '#2f7df6',
    dropShadow: false,
    widthScale: .73,
  },
  'cardCyan': {
    id: 'cardCyan',
    component: rectangle,
    title: 'Card',
    subtitle: 'Cyan',
    type: 'CARD',
    colorHex: '#b2dad9',
    dropShadow: false,
    widthScale: .73,
  },
  'cardGreen': {
    id: 'cardGreen',
    component: rectangle,
    title: 'Card',
    subtitle: 'Green',
    type: 'CARD',
    colorHex: '#75c245',
    dropShadow: false,
    widthScale: .73,
  },
  'cardOrange': {
    id: 'cardOrange',
    component: rectangle,
    title: 'Card',
    subtitle: 'Orange',
    type: 'CARD',
    colorHex: '#ee8437',
    dropShadow: false,
    widthScale: .73,
  },
  'cardRed': {
    id: 'cardRed',
    component: rectangle,
    title: 'Card',
    subtitle: 'Red',
    type: 'CARD',
    colorHex: '#a83273',
    dropShadow: false,
    widthScale: .73,
  },
  'dotBlack': {
    id: 'dotBlack',
    component: circle,
    title: 'Dot',
    subtitle: 'Black, Token',
    type: 'TOKEN',
    colorHex: '#000',
    dropShadow: false,
    widthScale: .73,
  },
  'dotBlue': {
    id: 'dotBlue',
    component: circle,
    title: 'Dot',
    subtitle: 'UF Blue, Token',
    type: 'TOKEN',
    colorHex: '#2f7df6',
    dropShadow: false,
    widthScale: .73,
  },
  'dotCyan': {
    id: 'dotCyan',
    component: circle,
    title: 'Dot',
    subtitle: 'UF Cyan, Token',
    type: 'TOKEN',
    colorHex: '#b2dad9',
    dropShadow: false,
    widthScale: .73,
  },
  'dotOrange': {
    id: 'dotOrange',
    component: circle,
    title: 'Dot',
    subtitle: 'UF Orange, Token',
    type: 'TOKEN',
    colorHex: '#ee8437',
    dropShadow: false,
    widthScale: .73,
  },
  'dotRed': {
    id: 'dotRed',
    component: circle,
    title: 'Dot',
    subtitle: 'Red, Token',
    type: 'TOKEN',
    colorHex: '#a83273',
    dropShadow: false,
    widthScale: .73,
  },
  'dotGray': {
    id: 'dotGray',
    component: circle,
    title: 'Dot',
    subtitle: 'Gray, Token',
    type: 'TOKEN',
    colorHex: '#8e97a0',
    dropShadow: false,
    widthScale: .73,
  },
  'dotGreen': {
    id: 'dotGreen',
    component: circle,
    title: 'Dot',
    subtitle: 'Green, Token',
    type: 'TOKEN',
    colorHex: '#75c245',
    dropShadow: false,
    widthScale: .73,
  },
  'spaceBox': {
    id: 'spaceBox',
    title: 'Space',
    subtitle: 'Box, Space',
    type: 'BOX',
    maxItems: 1,
    widthScale: .5,
    isScaffolded: false,
    imageSrc: spacer,
    thumbImageSrc: spacer,
  },
};
 export default shapes;
 